import { SelectTable } from "../../../models/types";

export const inputTypes: SelectTable[] = [
    {
        value: 1,
        name: 'עברי'
    },
    {
        value: 2,
        name: 'אנגלי'
    },
    {
        value: 3,
        name: 'תאריך'
    },
    {
        value: 4,
        name: 'טבלה נומרי'
    },
    {
        value: 5,
        name: 'טבלה'
    },
    {
        value: 6,
        name: 'דגם'
    },
    {
        value: 7,
        name: 'נומרי'
    },
    {
        value: 20,
        name: 'טבלה פנימית'
    },
    {
        value: 21,
        name: 'בוליאני'
    },
]


export const accountsTables: SelectTable[] = [
    {
        value: 12,
        name: 'כרטיסי הכנסות'
    },
    {
        value: 13,
        name: 'כרטיסי קניות/הוצאות'
    },
    {
        value: 14,
        name: 'כרטיסי בנק'
    },
    {
        value: 15,
        name: 'כרטיסי קופה'
    },
    {
        value: 16,
        name: 'כרטיסי מערכת'
    },
    {
        value: 18,
        name: 'שם מסמך'
    },
    {
        value: 19,
        name: 'מצב מסמך'
    },
];